import InitAnnoucementComponent from "./init-annoucement";
import { useSelector } from "react-redux";
import * as app from "@/app/app.slice";
import { useParams } from "react-router-dom";

function InitAnnoucement() {
  const { id } = useParams();

  const selectedAnnouncement = useSelector(app.selectAnnouncement(id));

  return <InitAnnoucementComponent startAnnoucement={selectedAnnouncement} />;
}
export default InitAnnoucement;
